import React, { useEffect } from "react";
import { useState } from "react";
import { BlogsMenuCard } from "../../../../shadcn/components/custom/BlogsMenuCard";
import BlogsHeroComponent from "./BlogsHeroComponent";
import { DateTime } from "luxon";

interface props {
  allLatestPosts?: any;
}
interface BlogsData {
  date?: string;
  title?: string;
  description?: string;
  imageLink?: string;
  link?: string;
  category?: string;
}

export const RelatedBlogsComponent = ({ allLatestPosts }: props) => {
  const [blogsData, setBlogsData] = useState<BlogsData[]>([]);
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const filteredData =
      [...(allLatestPosts || [])]
        .slice(0, 3)
        .map((blog: any, index: number) => ({
          date: DateTime.fromISO(blog.attributes.publishedAt)
            .setZone("Asia/Kolkata")
            .toFormat("dd MMM yyyy"),
          title: blog.attributes.title.split(" ").slice(0, 10).join(" "),
          description: blog.attributes.description
            .split(" ")
            .slice(0, 10)
            .join(" "),
          imageLink: blog.attributes.image.data.attributes.url,
          link: `/blogs/${blog.attributes.slug}`,
          category: blog.attributes.category.data.attributes.name,
        })) || [];
    setBlogsData(filteredData);
  }, []);

  return (
    <>
      {/* Web Component */}
      <div className="hidden lg:flex bg-brand-lightPink  mt-[80px] lg:mt-[100px]">
        <div className="px-customPaddingMobile lg:px-customPadding  py-6 lg:py-[50px]  2xl:w-[1340px] 2xl:px-0 2xl:mx-auto">
          <p className="font-spaceGrotesk font-normal text-mobile-h1 md:text-web-h2 leading-[61px] text-brand-bgBlack">
            RELATED BLOGS
          </p>
          <div className=" pb-1 space-y-11 lg:space-y-0 lg:grid lg:grid-cols-3 gap-6 lg:gap-y-[60px] mt-6 lg:mt-[70px]">
            {blogsData?.map((card, index) => (
              <div
                key={`residential_card_${card?.title}_${index}`}
                className={` w-full min-w-[320px] lg:min-w-0 hover:shadow-sm hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out`}
              >
                <BlogsMenuCard
                  textContent={card?.description}
                  tag={card?.category}
                  blogDate={card?.date}
                  imageLink={card?.imageLink}
                  blogLink={card?.link}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Component */}
      <BlogsHeroComponent
        title="RELATED BLOGS"
        className="lg:hidden mt-[100px] lg:mt-20 "
        headingClassName="text-start"
        blogsData={blogsData}
        progress={progress}
        setProgress={setProgress}
      />
    </>
  );
};

export default RelatedBlogsComponent;
